<template>
    <div>
        <div
            class="nc-detail__row nc-detail__row_field"
            :class="{ 'is-open': isOpen }"
            @click="isOpen = !isOpen"
        >
            <span class="nc-detail__label">{{ label }}:</span>
            <div class="nc-detail__field-trigger">
                <div class="nc-detail__field-content">
                    <template v-if="value">
                        <span class="nc-detail__field-value">{{ valueName }}</span>
                        <svg class="nc-detail__field-edit" width="12" height="12"><use href="#icon-edit"/></svg>
                    </template>
                    <template v-else>
                        <svg class="nc-detail__field-plus" width="11" height="11"><use href="#icon-plus"/></svg>
                        <span class="nc-detail__field-placeholder">{{ addPlaceholder }}</span>
                    </template>
                </div>
                <svg class="nc-detail__field-chevron" width="14" height="14"><use href="#icon-angle-down"/></svg>
            </div>
        </div>
        <transition
            @before-enter="onBeforeEnter"
            @enter="onEnter"
            @after-enter="onAfterEnter"
            @before-leave="onBeforeLeave"
            @leave="onLeave"
            @after-leave="onAfterLeave"
        >
            <div v-if="isOpen" class="nc-detail__panel">
                <div class="nc-detail__panel-row">
                    <v-custom-select
                        class="size_medium"
                        :value="pendingValue"
                        :list="list"
                        :placeholder="selectPlaceholder"
                        @input="pendingValue = $event"
                    />
                </div>
                <transition name="nc-fade">
                    <div class="nc-detail__panel-row">
                        <v-button
                            size="full-width"
                            class="button_size_medium button_color_black"
                            :loading="loading"
                            :disabled="loading"
                            @click="handleConfirm"
                        >
                            {{ buttonText }}
                        </v-button>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
import vCustomSelect from '../../global/CustomSelect.vue'
import vButton from '../../global/vButton.vue'

export default {
    name: 'NewChatExpandableField',
    components: { vCustomSelect, vButton },
    props: {
        label:            { type: String,           required: true },
        value:            { type: [String, Number], default: '' },
        valueName:        { type: String,           default: '' },
        addPlaceholder:   { type: String,           default: '' },
        list:             { type: Array,            default: () => [] },
        selectPlaceholder:{ type: String,           default: '' },
        loading:          { type: Boolean,          default: false },
        buttonText:       { type: String,           required: true },
    },
    data() {
        return {
            isOpen: false,
            pendingValue: this.value,
        }
    },
    watch: {
        // Sync pendingValue when panel opens so stale selection is discarded
        isOpen(val) {
            if (val) this.pendingValue = this.value
        },
        // Keep pendingValue in sync if parent updates the confirmed value externally
        value(val) {
            this.pendingValue = val
        },
    },
    methods: {
        handleConfirm() {
            this.isOpen = false
            this.$emit('confirm', this.pendingValue)
        },
        onBeforeEnter(el) {
            el.style.height = '0px'
            el.style.opacity = '0'
            el.style.overflow = 'hidden'
        },
        onEnter(el, done) {
            el.offsetHeight // force reflow
            el.style.transition = 'height 0.28s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.22s ease'
            el.style.height = el.scrollHeight + 'px'
            el.style.opacity = '1'
            const handler = (e) => {
                if (e.propertyName === 'height') {
                    el.removeEventListener('transitionend', handler)
                    done()
                }
            }
            el.addEventListener('transitionend', handler)
        },
        onAfterEnter(el) {
            el.style.height = ''
            el.style.overflow = ''
            el.style.opacity = ''
            el.style.transition = ''
        },
        onBeforeLeave(el) {
            el.style.height = el.scrollHeight + 'px'
            el.style.overflow = 'hidden'
        },
        onLeave(el, done) {
            el.offsetHeight // force reflow
            el.style.transition = 'height 0.22s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.18s ease'
            el.style.height = '0px'
            el.style.opacity = '0'
            const handler = (e) => {
                if (e.propertyName === 'height') {
                    el.removeEventListener('transitionend', handler)
                    done()
                }
            }
            el.addEventListener('transitionend', handler)
        },
        onAfterLeave(el) {
            el.style.height = ''
            el.style.overflow = ''
            el.style.opacity = ''
            el.style.transition = ''
        },
    },
}
</script>